import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Area, AreaChart } from 'recharts';
const data = [{
  time: '6AM',
  without: 85,
  with: 45
}, {
  time: '9AM',
  without: 90,
  with: 40
}, {
  time: '12PM',
  without: 75,
  with: 35
}, {
  time: '3PM',
  without: 70,
  with: 30
}, {
  time: '6PM',
  without: 80,
  with: 35
}, {
  time: '9PM',
  without: 95,
  with: 30
}, {
  time: '12AM',
  without: 100,
  with: 25
}];
export function CortisolGraph() {
  return <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-2xl p-8 my-12" data-id="element-168">
      <div className="max-w-4xl mx-auto" data-id="element-169">
        <h3 className="text-2xl font-bold text-gray-900 mb-2 text-center" data-id="element-170">
          How LyraSleep Regulates Your Cortisol Levels
        </h3>
        <p className="text-gray-600 text-center mb-8" data-id="element-171">
          See the dramatic difference in cortisol patterns with consistent
          LyraSleep use
        </p>

        <div className="bg-white rounded-xl p-6 shadow-lg" style={{
        height: '400px'
      }} data-id="element-172">
          <ResponsiveContainer width="100%" height="100%" data-id="element-173">
            <AreaChart data={data} data-id="element-174">
              <defs data-id="element-175">
                <linearGradient id="colorWithout" x1="0" y1="0" x2="0" y2="1" data-id="element-176">
                  <stop offset="5%" stopColor="#ef4444" stopOpacity={0.3} data-id="element-177" />
                  <stop offset="95%" stopColor="#ef4444" stopOpacity={0} data-id="element-178" />
                </linearGradient>
                <linearGradient id="colorWith" x1="0" y1="0" x2="0" y2="1" data-id="element-179">
                  <stop offset="5%" stopColor="#10b981" stopOpacity={0.3} data-id="element-180" />
                  <stop offset="95%" stopColor="#10b981" stopOpacity={0} data-id="element-181" />
                </linearGradient>
              </defs>
              <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" data-id="element-182" />
              <XAxis dataKey="time" stroke="#6b7280" style={{
              fontSize: '12px'
            }} data-id="element-183" />
              <YAxis stroke="#6b7280" style={{
              fontSize: '12px'
            }} label={{
              value: 'Cortisol Level',
              angle: -90,
              position: 'insideLeft'
            }} data-id="element-184" />
              <Tooltip contentStyle={{
              backgroundColor: 'white',
              border: '1px solid #e5e7eb',
              borderRadius: '8px',
              padding: '8px 12px'
            }} data-id="element-185" />
              <Area type="monotone" dataKey="without" stroke="#ef4444" strokeWidth={3} fill="url(#colorWithout)" name="Without LyraSleep" data-id="element-186" />
              <Area type="monotone" dataKey="with" stroke="#10b981" strokeWidth={3} fill="url(#colorWith)" name="With LyraSleep" data-id="element-187" />
            </AreaChart>
          </ResponsiveContainer>
        </div>

        <div className="mt-8 flex justify-center gap-8" data-id="element-188">
          <div className="flex items-center gap-2" data-id="element-189">
            <div className="w-4 h-4 bg-red-500 rounded" data-id="element-190"></div>
            <span className="text-sm text-gray-600" data-id="element-191">Without LyraSleep</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-192">
            <div className="w-4 h-4 bg-green-500 rounded" data-id="element-193"></div>
            <span className="text-sm text-gray-600" data-id="element-194">With LyraSleep</span>
          </div>
        </div>

        <div className="mt-6 text-center" data-id="element-195">
          <p className="text-sm text-gray-600 max-w-2xl mx-auto" data-id="element-196">
            <strong data-id="element-197">The Science:</strong> LyraSleep's adaptogenic blend helps
            regulate cortisol levels, reducing stress response and promoting
            balanced hormone function throughout the day and night.
          </p>
        </div>
      </div>
    </div>;
}